import React, {useCallback, useEffect, useRef, useState} from 'react'
import Modal, {ModalBody, ModalFooter, ModalHeader, ModalTitle} from "../../../../../components/bootstrap/Modal";
import Button from "../../../../../components/bootstrap/Button";
import Label from "../../../../../components/bootstrap/forms/Label";
import Textarea from "../../../../../components/bootstrap/forms/Textarea";
import Icon from "../../../../../components/icon/Icon";
import CustomSelect from '../../../../../components/bootstrap/forms/CustomSelect';
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";
import moment from "moment/moment";
import CompanyService from "../../../../../services/CompanyService";
import showNotification from "../../../../../components/extras/showNotification";
import {useMst} from '../../../../../models';
import UserService from "../../../../../services/UserService";
import {checkMoment} from '../../../../../lib/Util';
import ApprovalModalMini, {ApprovalLineEditButton} from "../../../Approval/components/ApprovalModalMini";
import Avatar from "react-avatar";
import { getApprovalUserValue, withApprovalLineLangs } from 'helpers/personNameI18n';
import { useLineCcMerge } from 'helpers/approvalCcUsers';

// 부모는 새로고침 함수를 refresh로 넘긴다(reFresh로 넘기는 곳도 있어 둘 다 받음)
const WorkRecodeChangeModal = ({ isOpen, setIsOpen, item, changeWorkTime, setIsMapModal, reFresh: reFreshProp, refresh, calendarDate, setIsModal, groupId }) => {
    const reFresh = reFreshProp || refresh;
    const { user, company } = useMst();
    const { t } = useTranslation()
    const approvalSelf = company.approvalSelf;
    const selectRef = useRef(null);
    const [approvalList, setApprovalList] = useState([]);
    const [isModalOpen4, setIsModalOpen4] = useState(false);
    const [option, setOption] = useState({});
    const getApprovalLine = useCallback(async () => {
        await UserService.getApproval(company.get.id, { userId: user.id, departId: company.get?.departInfos[0]?.departId || '', option: 'up' }).then((res) => {
            setApprovalList(res?.data || []);
        });
    }, [user.id, company]);
    const restRequest = useFormik({
        initialValues: {
            id: 0,
            restType: '',
            cutOffTime: 0,
            isAllTime: true,
            companyId: company.get.id,
            type: 'REST',
            //dateRange: selectionRange,
            timeRange: ['', ''],
            startAt: '',
            endAt: '',
            etc: '',
            memo: '',
            approvailLine: [],
            option: {},
            isApproval: false,
            ccUsers: [],
        },
        validate: (values) => {
            const errors = {};

            if(values?.dateRange?.length === 0){
                errors.dateRange = t('requestOTpopup.dateSelectionRequired');
            }
            if(values?.restType === ''){
                errors.restType = t('requestAnnualLeavePopup.vacationTypeSelectionRequired');
            }
            /* if (selectedTimeBtn.value > 0) {
              if(attendInfo?.requestWorkTime) {
                if (values.startAt !== '' && values.startAt < attendInfo?.requestWorkTime[0]) {
                  errors.startAt = '근무시간 이외 시간은 입력할 수 없습니다';
                }
                if (values.endAt !== '' && values.endAt > attendInfo?.requestWorkTime[1]) {
                  errors.endAt = '근무시간 이외 시간은 입력할 수 없습니다';
                }
              }
              if (moment(values.endAt, "HH:mm") < moment(values.startAt, "HH:mm")){
                errors.endAt = '종료시간은 시작시간보다 빠를 수 없습니다';
              }
            }
            */
            // if(values?.approvailLine?.length === 0){
            // 	errors.approvailLine = t('결재라인 선택은 필수입니다');
            // }

            // console.log(errors)
            return errors;
        },
        onSubmit: async (values) => {
            if (values.id === 0) delete values.id;

            // console.log('values >>',values)
            // if(parseFloat(remainingRest) <= 0){
            // 	showNotification(t('휴가신청'), t('잔여 연차를 확인해주세요'), 'danger');
            // } else {
            // if(!cutOffRestday)
            // 	delete values.cutOffTime

            // // endAt 제어..확인하세요..
            // if(values.endAt === 'Invalid date')
            // 	values.endAt = '';

            // if(remainingRest <= 0){
            // 	showNotification(t('휴가신청'), t('잔여휴가를 확인해주세요'), 'danger');
            // } else {
            const forms = new FormData();

            files?.length > 0 && console.log('files >>', files);

            files?.map( file => {
                forms.append('files', file);
            });

            forms.append('data', JSON.stringify(values));

            // return;
            // if(deleteFile?.id) {
            // 	const deleteF = await CompanyService.deleteFile(deleteFile?.id);
            // 	console.log('deleteF', deleteF)
            // }

            await CompanyService.restdayRequest(forms).then((res) => {
                if (res?.data) {
                    props.setIsOpen(false);
                    setOpenSuccessRequestModal(true);
                } else {
                    showNotification(t('휴가 신청'), t('휴가신청에 문제가 발생 했습니다.'), 'danger');
                }
            });
            // }
        },
    });

    const mergeLineCc = useLineCcMerge(); // 결재라인 선택 시 직접 고른 참조자 유지
    const workRequest = useFormik({
        initialValues: {
            attendId: item.attendId || null,
  	  		userId: item.userId,
  	  		companyId: company.get.id,
  	  		sdate: item?.id ? moment(item.dates.workStartTime).format('YYYY-MM-DD')
  	  				        : item?.history && item?.history[0]?.inputTime ? moment(item?.history[0]?.inputTime).format('YYYY-MM-DD') : item.stimeReal ? moment(item.stimeReal).format('YYYY-MM-DD') : moment(checkMoment(item.day[0]), 'YYYY-MM-DD (dd)').format('YYYY-MM-DD'),
  	  		stime: item?.id ? moment(item.dates.workStartTime).format('HH:mm')
  	  				        : item?.history && item?.history[1]?.inputTime ?  moment(item?.history[0]?.inputTime).format('HH:mm') : item.stimeReal ? moment(item.stimeReal).format('HH:mm') : null,
  	  		edate: item?.id ? moment(item.dates.workEndTime).format('YYYY-MM-DD')
  	  				        : item?.history && item?.history[1]?.inputTime ? moment(item?.history[1]?.inputTime).format('YYYY-MM-DD') : item.etimeReal ? moment(item.etimeReal).format('YYYY-MM-DD') : moment(checkMoment(item.day[0]), 'YYYY-MM-DD (dd)').format('YYYY-MM-DD'),
  	  		etime: item?.id ? moment(item.dates.workEndTime).format('HH:mm')
  	  				        : item?.history && item?.history[1]?.inputTime ? moment(item?.history[1]?.inputTime).format('HH:mm')  : item.etimeReal ? moment(item.etimeReal).format('HH:mm') : null,
  	  		sGps: item?.id ? item.gps && item.gps[0] && item.gps[0]?.coordinates ? {
  	  			type: 's',
  	  			lat: item.gps[0]?.coordinates[0] || null,
  	  			lng: item.gps[0]?.coordinates[1] || null
  	  		} : null : null,
  	  		eGps: item?.id ? item.gps && item.gps[1] && item.gps[1]?.coordinates ? {
  	  			type: 'e',
  	  			lat: item.gps[1]?.coordinates[0] || null,
  	  			lng: item.gps[1]?.coordinates[1] || null
  	  		} : null : null,
            etc: !item?.id ? item.etc : '', // 신청 사유
            approvals: item.approvals || [], // 새 결재라인 정보
            option: option || {},
            approvailLine: [],
            ccUsers: item.ccUsers || [], // 참조자들
        },
        onSubmit: async(values) => {
            values.startTime = changeWorkTime[0];
            values.endTime = changeWorkTime[1];
            values.name = user.name;
            values.adminId = user.id;
            values.departmentName = user.userDepartment;

            await CompanyService.modifyWorkRecordRequest4(values).then((response) => {
                if (response.code === 200) {
                    showNotification(t('근무기록 수정 승인요청'), t('근무기록 수정 승인요청이 완료되었습니다'), 'info')
                    setIsModal(false);
                    setIsMapModal(false);
                    reFresh?.([
  	  	  	  	    	{
  	  	  	  	    		key: 'selection',
  	  	  	  	    		startDate: moment(calendarDate?.[0]?.startDate).toDate(),
  	  	  	  	    		endDate: moment(calendarDate?.[0]?.endDate).toDate(),
  	  	  	  	    	},
  	  	  	  	    ], groupId, 'day');
                } else {
                    showNotification(t('근무기록 수정 승인요청'), response.message,'danger')
                }
            })
        }
    })

    const approvailLineUser = restRequest?.values?.approvailLine[0]?.line[0]?.user;

    const countApprovalUsers = restRequest?.values?.approvailLine
        ?.map((i) => i.line)
        .reduce((accumulator, currentArray) => {
          return accumulator + currentArray.length;
        }, 0);

    useEffect(() => {
        getApprovalLine();
    }, [getApprovalLine]);

    const newStyle = {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#D9D9D9',
        backgroundColor: 'white',
        padding: '10px 10px 10px 10px',
        marginRight: 20,
        resize: 'none',
    };
    return (
        <Modal
            isCentered
            isStaticBackdrop
            setIsOpen={setIsOpen}
            isOpen={isOpen}
        >
            <div className='modal-wraped mx-3'>
                <ModalHeader className='d-block'>
  	  	  	  		<ModalTitle className='fw-bolder'>근무기록 수정</ModalTitle>
                    <p className='mt-2'>{t('마감된 근무기록 수정은 승인이 필요합니다.')}</p>
  	  	  	    </ModalHeader>
                <ModalBody>
                  <form>
                    <div className='row align-items-center'>
                      <Label className='form-label col-form-label col-sm-4 ps-4 fw-bold text-dark'>
                        {t('결재라인')}
                        <span className='text-danger ms-1'>*</span>
                      </Label>
                      <div className='col-sm-8'>
                        {approvalSelf ? (
                          /* 회사지정 결재라인 - 콤보박스 */
                          <CustomSelect ariaLabel='결재라인'
                            ref={selectRef}
                            style={newStyle}
                            list={[...approvalList]?.map((v) => ({ value: v.id, label: v.name }))}
                            placeholder={t('requestEditPopup.pleaseSelectApprovalLine')}
                            onChange={(e) => {
                              const approval = approvalList.find((v) => parseInt(v.id) === parseInt(e.target.value));
                              workRequest.setFieldValue('approvailLine', approval?.lines || approval?.line || []);
                              workRequest.setFieldValue('approvals', approval?.lines || approval?.line || []);
                              workRequest.setFieldValue('option', approval?.option || {});
                              workRequest.setFieldValue('ccUsers', mergeLineCc(workRequest.values.ccUsers, approval?.ccUsers));
                              setOption(approval?.option || {});
                            }}
                          />
                        ) : (
                          /* 직접 지정 결재라인 - 지정하기 버튼 */
                          <Button
                            type='button'
                            style={{ borderRadius: 8 }}
                            isOutline
                            color='info'
                            onClick={() => setIsModalOpen4(true)}
                          >
                            <div className='d-flex align-items-center'>
                              <Icon icon='Search' size='lg' color='info' />
                              <span className='custom-write-button-margin'>{t('userVacation.assign')}</span>
                            </div>
                          </Button>
                        )}
                      </div>
                      {/* 결재라인 편집 버튼·경고문구·결재자 목록은 콤보박스 아래 줄에 노출 */}
                      <div className='col-sm-8 offset-sm-4'>
                        {/* 결재라인 회사지정이면 결재라인 편집 버튼 항상 노출 */}
                        {approvalSelf && (
                          <ApprovalLineEditButton approvalLine={workRequest?.values?.approvailLine} onClick={() => setIsModalOpen4(true)} />
                        )}

                        {/* 결재라인 미선택 경고 */}
                        {workRequest?.values?.approvailLine?.length === 0 && (
                          <div className='text-danger mt-2'>
                            <Icon icon='InfoOutline' className='mx-2'/>
                            <span>{t('staggeredCommutePopup.approvalLineSelectionRequired')}</span>
                          </div>
                        )}

                        {/* 선택된 결재자 목록 */}
                        {workRequest?.values?.approvailLine?.length > 0 && (
                          <div className='rank_list mt-2'>
                            {workRequest.values.approvailLine.flatMap(lineItem => lineItem.line?.map(l => withApprovalLineLangs(l)) || []).map((u, index) => (
                              <Button
                                key={`approval-user-${u.userId}-${index}`}
                                onClick={() => {
                                  const next = workRequest.values.approvailLine
                                    .map(container => {
                                      const nextLine = container.line.filter(l => l.user.userId !== u.userId);
                                      return nextLine.length ? { ...container, line: nextLine } : null;
                                    })
                                    .filter(Boolean);
                                  workRequest.setFieldValue('approvailLine', next);
                                  workRequest.setFieldValue('approvals', next);
                                  if (approvalSelf && selectRef.current) selectRef.current.value = '';
                                }}
                              >
                                <span className='d-flex justify-content-between align-items-center'>
                                  <span className='user_info'>
                                    <Avatar round textSizeRatio={0.5} size={25} name={u?.name || ''} src={u?.profile || null} />
                                    <span className='ms-2'>{getApprovalUserValue(u)} {getApprovalUserValue(u, 'rank')}</span>
                                  </span>
                                  <Icon icon='Close' size='md' />
                                </span>
                              </Button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* 결재라인 회사지정이거나 참조자가 이미 있는 경우 참조 섹션 노출 */}
                    {workRequest?.values?.ccUsers?.length > 0 && (
                    <div className='row align-items-center mt-4'>
                      <Label className='form-label col-form-label col-sm-4 ps-4 fw-bold text-dark'>{t('참조')}</Label>
                      <div className='col-sm-8'>
                        {/* 참조자 목록 */}
                        {workRequest?.values?.ccUsers?.map((v, i) => (
                          <Button
                            key={`ccUsers-${i}`}
                            style={{ borderRadius: 6, borderWidth: 1, borderColor: '#D9D9D9', margin: 5, backgroundColor: '#F8F9FA' }}
                            className='py-1 px-2'
                            onClick={() => {
                              const newCcUsers = workRequest.values.ccUsers.filter((_, idx) => idx !== i);
                              workRequest.setFieldValue('ccUsers', newCcUsers);
                            }}
                          >
                            <Icon icon='Visibility' size='md' style={{ color: 'grey' }} />
                            <span className='mx-3'>{getApprovalUserValue(v)}</span>
                            <Icon icon='Close' size='md' />
                          </Button>
                        ))}
                      </div>
                    </div>
                    )}

                    <div className='row my-4'>
                      <Label className='form-label col-form-label col-sm-4 ps-4 fw-bold text-dark'>{t('사유')}</Label>
                      <div className='col-sm-8'>
                        <Textarea
                          name={'etc'}
                          ariaLabel='With textarea'
                          placeholder={t('requestEditPopup.inputReasonOptional')}
                          value={workRequest.values.etc ? workRequest.values.etc : ''}
  	  	  	  					  onChange={workRequest.handleChange}
                        />
                      </div>
                    </div>
                  </form>
                </ModalBody>
                <ModalFooter>
                  <Button
                    style={{
                      borderRadius: 7,
                      border: '1px solid #e6e7e7'
                    }}
                    onClick={() => setIsOpen(false)}
                  >
                    <span className='text-muted px-4'>{t('취소')}</span>
                  </Button>
                  <Button
                    style={{
                      borderRadius: 7,
                    }}
                    color='info'
                    onClick={() => {
                      workRequest.handleSubmit();
                      setIsOpen(false);
                    }}
                  >
                    <span className='px-4'>{t('requestOTpopup.approvalRequest')}</span>
                  </Button>
                </ModalFooter>
                <ApprovalModalMini setIsOpen={setIsModalOpen4} isOpen={isModalOpen4} restRequest={workRequest} />
            </div>
        </Modal>
    )
}

export default React.memo(WorkRecodeChangeModal)